import { render, staticRenderFns } from "./TraxUiToastr.vue?vue&type=template&id=19fa9c37"
import script from "./TraxUiToastr.vue?vue&type=script&lang=js"
export * from "./TraxUiToastr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports